import React from 'react';
import { PageTopBreadcrumb } from '../../../core/components/types';
import PageTop from '../../../core/components/PageTop';
import { ROUTE_LIST } from '../provider_const';
import { useProviderEditInit } from './pagehooks/useProviderEditInit';
import { useProviderEditStore } from './pagehooks/useProviderEditStore';
import ProviderEditTabs from './tabs/ProviderEditTabs';

const PageAdminProviderEdit = (): JSX.Element => {
    const title = useProviderEditInit();
    const breadcrumb: PageTopBreadcrumb = {
        title: 'Return to Provider List',
        icon: 'sprite-ops',
        route: ROUTE_LIST,
    };

    return (
        <>
            <PageTop
                title={title}
                icon="sprite-ops"
                breadcrumb={breadcrumb}
            />
            <div className="provider-feature provider-edit">
                <Content />
            </div>
        </>
    );
};

const Content = (): JSX.Element => {
    const { state } = useProviderEditStore();

    // wait for init
    if (state.init) {
        return <></>;
    }

    return <ProviderEditTabs />;
};

export default PageAdminProviderEdit;
